import {initSectionAccordion} from './section.accordion';
import {initHeader} from './header';
import {initTextWithMedia} from './section.text-with-media';
import {initContacts} from './section.contacts';
import {initProjectInfo} from './section.project-info';
import {initMapComponent} from './section.map';
import {initProjectCard} from './section.project-card';
import {initSlider} from './section.slider';
import {initPress} from './section.press';
import {initDocuments} from './section.documents';
import {initTimelineHistory} from './section.text';
import {initShowreel} from './section.showreel';
import {initVideo} from './section.video';

export const initComponents = () => {
	initSectionAccordion();
	initHeader();
	initTextWithMedia();
	initContacts();
	initProjectInfo();
	initProjectCard();
	initMapComponent();
	initSlider();
	initPress();
	initDocuments();
	initTimelineHistory();
	initShowreel();
	initVideo();
};
